import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Theme } from '@material-ui/core';
import colors from '../../../../../styles/colors';
import { Cancel, CheckCircle, Sync } from '@material-ui/icons';
const useStyles = makeStyles((theme: Theme) => ({
  spinAnimation: {
    animation: '$spin 1s linear infinite'
  },
  '@keyframes spin': {
    '0%': {
      opacity: 1,
      transform: 'rotate(0deg)'
    },
    '50%': {
      transform: 'rotate(180deg)'
    },
    '100%': {
      opacity: 1,
      transform: 'rotate(360deg)'
    }
  },
  editStatus: {
    color: colors.assignment.lightgrey,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'right',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));

interface AutoSaveLoaderProps {
  isSaving: boolean | undefined;
  isDataEdited: boolean | undefined;
}
const AutoSaveLoader = (props: AutoSaveLoaderProps) => {
  const { isSaving, isDataEdited } = props;
  const classes = useStyles();
  return (
    <div className={classes.editStatus}>
      {isSaving ? (
        <Box display={'flex'} alignItems={'center'}>
          <Sync
            className={classes.spinAnimation}
            style={{ color: colors.orange }}
          />{' '}
          &nbsp;
          <span>Saving changes</span>
        </Box>
      ) : (
        <Box display={'flex'} alignItems={'center'}>
          {isDataEdited ? (
            <>
              <Cancel style={{ color: colors.red }} />
              &nbsp;<span>Unsaved changes</span>
            </>
          ) : (
            <>
              <CheckCircle style={{ color: colors.green }} />
              &nbsp;<span>All changes are saved</span>
            </>
          )}
        </Box>
      )}
    </div>
  );
};

export default AutoSaveLoader;
